module.exports = __webpack_public_path__ + "static/img/DTU透明倒影灰底.4f482bf2.png";